import { BaseRouteService } from 'core/services';

class BranchRouteService extends BaseRouteService {
    constructor() {
        super('branches');
    }

    find(filter) {
        return super.find(this.base + '/{?searchQuery,page,rpp,sort,embed,fields}', filter);
    }
}

export default BranchRouteService;
